export default "__VITE_ASSET__lN8a68BN__"